var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.currentUser.profile.interface === 'Worker')?_c('worker-home'):_c('requester-home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }